import React, { createContext, useState, useEffect, useCallback } from "react";
import { useAuth } from "./AuthContext"; // 🔥 Додано
import axiosInstance from "../api/axiosInstance";

export const OrderContext = createContext();

export const OrderProvider = ({ children }) => {
  const [orders, setOrders] = useState([]);
  const { isLoggedIn } = useAuth(); // ✅ Отримуємо статус авторизації

  const fetchOrders = useCallback(async () => {
    try {
      const response = await axiosInstance.get("/orders");
      setOrders(response.data);
    } catch (error) {
      console.error("❌ Помилка завантаження замовлень:", error);
      // ⛔️ Не показуємо alert, якщо неавторизований
      if (isLoggedIn) {
        alert("Не вдалося завантажити замовлення.");
      }
    }
  }, [isLoggedIn]);

  const fetchOrderById = useCallback(async (orderNumber) => {
    try {
      const response = await axiosInstance.get(
        `/orders/by-number/${orderNumber}?t=${Date.now()}`
      );
      const newOrder = response.data;

      setOrders((prev) =>
        prev.map((order) =>
          order.orderNumber === Number(orderNumber) ? newOrder : order
        )
      );
      return newOrder;
    } catch (error) {
      console.error("❌ Помилка завантаження замовлення:", error);
      return null;
    }
  }, []);

  const addOrder = useCallback(async (newOrder) => {
    try {
      const response = await axiosInstance.post("/orders", newOrder);
      setOrders((prev) => [...prev, response.data]);
      return response.data;
    } catch (error) {
      console.error("❌ Помилка створення замовлення:", error);
      throw error;
    }
  }, []);

  const updateOrderStatus = async (orderNumber, newStatus) => {
    try {
      const response = await axiosInstance.put(
        `/orders/by-number/${Number(orderNumber)}`,
        { status: newStatus }
      );

      setOrders((prev) =>
        prev.map((order) =>
          order.orderNumber === Number(orderNumber)
            ? { ...order, status: newStatus }
            : order
        )
      );

      return response.data;
    } catch (error) {
      console.error("❌ Помилка оновлення статусу:", error);
      throw error;
    }
  };

  const updateOrder = useCallback(async (orderNumber, updatedData) => {
    try {
      const response = await axiosInstance.put(
        `/orders/by-number/${orderNumber}`,
        updatedData
      );
      const updatedOrder = response.data;

      setOrders((prev) =>
        prev.map((order) =>
          order.orderNumber === Number(orderNumber) ? updatedOrder : order
        )
      );

      return updatedOrder;
    } catch (error) {
      console.error("❌ Помилка оновлення замовлення:", error);
      throw error;
    }
  }, []);

  // 🔄 Завантажуємо замовлення ТІЛЬКИ після авторизації
  useEffect(() => {
    if (isLoggedIn) {
      fetchOrders();
    }
  }, [isLoggedIn, fetchOrders]);

  return (
    <OrderContext.Provider
      value={{
        orders,
        setOrders,
        fetchOrders,
        fetchOrderById,
        addOrder,
        updateOrderStatus,
        updateOrder,
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};
